// extracted by mini-css-extract-plugin
module.exports = {"cell":"ScaleImageCell-module--cell--312lo","scaleArea":"ScaleImageCell-module--scaleArea--3BLXw","image":"ScaleImageCell-module--image--2CNsy"};